import Vue from 'vue'
import AIAssistant from '@klook/admin-ai-assistant'
// 依赖 body.ai-chat-open class 让 antd-vue drawer/notification/modal 避让 AI 面板宽度；
// class 由下面 syncAIChatBodyClass 维护
import '@klook/admin-ai-assistant/compat'
import { registerAllRoutes } from '@klook/admin-ai-workflow-contracts'
import { registerWorkflows } from './workflows'
import { registerPersistentTools } from './persistent-tools'
import { isMerchant } from '@/env'

export function registerAIAssistant(ctx) {
  Vue.use(AIAssistant, {
    platform: isMerchant ? 'merchant' : 'admin',
    // iframe 内无法通过组件实例访问 Vue.prototype.$router（getter 须实例触发），
    // 必须显式注入给 toolkit.navigate / builtin redirect-router
    getRouter: () => ctx.router
  })

  registerAllRoutes(Vue.prototype.$ai)
  registerWorkflows(Vue.prototype.$ai)
  registerPersistentTools(Vue.prototype.$ai)

  syncAIChatBodyClass(Vue.prototype.$ai)
}

/**
 * 监听 AI Chat 面板开合状态，同步 body class 并派发 resize 事件。
 *
 * @param {import('@klook/admin-ai-assistant').AIInstance} ai
 */
function syncAIChatBodyClass(ai) {
  if (typeof document === 'undefined' || !ai || !ai.store) return

  const BODY_CLASS = 'ai-chat-open'

  // 借 new Vue() 空实例当 $watch 工厂，观察 ai.store.state（Vue.observable）
  const watcher = new Vue({
    computed: {
      isOpen() {
        return ai.store.state.isOpen
      }
    },
    watch: {
      isOpen: {
        immediate: true,
        handler(open) {
          document.body.classList.toggle(BODY_CLASS, !!open)
          // 等 CSS transition 启动后再让依赖 clientWidth 的组件（ECharts、虚拟列表等）重新测量
          if (typeof window !== 'undefined' && typeof window.requestAnimationFrame === 'function') {
            window.requestAnimationFrame(() => {
              window.dispatchEvent(new Event('resize'))
            })
          }
        }
      }
    }
  })

  return watcher
}
